import { render, staticRenderFns } from "./NationalTrademarkCountryForm.vue?vue&type=template&id=7132c610&"
import script from "./NationalTrademarkCountryForm.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkCountryForm.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkCountryForm.vue?vue&type=style&index=0&id=7132c610&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports